
import { computed, defineComponent } from 'vue';
import Icone from '@/core/components/UI/Icone.vue';

export default defineComponent({
  name: 'CampoSenha',
  components: {
    Icone,
  },
  props: {
    valor: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: string) => {
        if (valor === undefined || valor === null) {
          emit('update:valor', '');
        } else {
          emit('update:valor', valor);
        }
      },
    });

    return {
      props,
      computedValor,
    };
  },
});
